import "babel-polyfill";
import jQuery from "jquery";

window.$ = window.jQuery = $ = jQuery;
import 'bootstrap';
import "slick-lightbox";
import "slick-carousel";
// import "sticky-kit/dist/sticky-kit.js";
import "waypoints/lib/jquery.waypoints";
import "waypoints/lib/shortcuts/inview";

import "slicknav/dist/jquery.slicknav";

// Theme (active.js)
import "magnific-popup";
import "jquery.appear";

import "slicknav/jquery.slicknav";

// import scrollMagic from "scrollmagic";
// import gsap from "gsap";
//import "./plugins/bsnav.js";

import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/brands'
import '@fortawesome/fontawesome-free/js/v4-shims'

// Import everything from autoload
// import "./autoload/**/*";


// import onscreenJs from "./utils/onscreen";
// onscreenJs();

// var controller = new ScrollMagic.Controller();
// var scene = new ScrollMagic.Scene();

// import "jquery-lazy/plugins/jquery.lazy.av"
// import "jquery-lazy/plugins/jquery.lazy.picture"
//import "waypoints/src/waypoint";

jqueryLazy();
import jqueryLazy from "./utils/jquery-lazy";

// import scrollmagicUtil from "./utils/scrollmagic-util";
// scrollmagicUtil();

// import scrollrevealJs from "./utils/scrollreveal";
// scrollrevealJs();


import aosJs from "./utils/aos-js";
aosJs();

// import wowJs from "./utils/wow-js";
// wowJs();

// import themeJs from "./utils/theme";
// themeJs();

// import cursorJs from "./utils/cursor";
// cursorJs();

import navlinkJs from "./utils/nav-link";
navlinkJs();

import slickJs from "./utils/slick";
slickJs();

import apartmentsCategorySelectJs from "./utils/apartments-category-select";
apartmentsCategorySelectJs();

import scrollJs from "./utils/scroll-js";
scrollJs();

import preloaderJs from "./utils/preloader-js";
preloaderJs();

// Theme JS
import "./active";

import sidebarJs from "./utils/sidebar";
sidebarJs($);


$(document).ready(function () {

  $(".js-slick-lightbox").slickLightbox({
    itemSelector: "> a"
  })

  $('.js--sidebar-phone-icon').on('touchstart tap', function (e) {
    e.preventDefault();
    $('.js--sidebar-phone-number').toggleClass('is--active');
  });

});

